import React, { useState } from 'react';
import { translate } from '../Services/translation';
import { get } from '../Services/http';

const ProductPdfButton = () => {
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState();

    const onClick = async () => {
        setLoading(true);
        try {
            await get('/api/pdfGenerator?url=' + window.location.href + '?showAsPdf=true')
                .then((resp) => resp.blob()).then((myBlob) => {
                    window.open(URL.createObjectURL(myBlob))
                });
            setLoading(false);
            setErrorMsg(null);
        } catch (error) {
            error.response.text().then((x) => setErrorMsg(x));
            setLoading(false);
        }
    };

    return (
        <>
            <button className="product-info__button" onClick={() => onClick()}>
                {loading ? (
                    <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                ) : (
                    <>
                        <i className="product-info__button__pdf__icon"></i>
                        <span className="product-info__button__pdf__text">
                            {' '}
                            {translate('product.downloadButtonText')}{' '}
                        </span>
                    </>
                )}
            </button>
            {errorMsg && (
                <p className="product-info__button__pdf__error-text">
                    {translate('product.action.pdf.error')}
                </p>
            )}
        </>
    );
};
export default ProductPdfButton;
